import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { MapPin, ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel } from "@/components/ui/dropdown-menu";

export const getCurrentDistrict = () => localStorage.getItem("tr_district") || "";
export const setCurrentDistrict = (id) => {
  if (id) localStorage.setItem("tr_district", id); else localStorage.removeItem("tr_district");
  window.dispatchEvent(new Event("tr-district-change"));
  window.location.reload();
};

export function DistrictSelector() {
  const [districts, setDistricts] = useState([]);
  const [current, setCurrent] = useState(getCurrentDistrict());
  useEffect(() => {
    api.get("/agency-districts").then((r) => setDistricts(r.data.items || [])).catch(() => {});
  }, []);
  if (districts.length < 1) return null;
  const activeName = districts.find((d) => d.org_id === current)?.name || "All my districts";
  const choose = (id) => { setCurrent(id); setCurrentDistrict(id); };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="district-selector" aria-label={`District: ${activeName}`} title={activeName} className="flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-sm hover:border-brand">
          <MapPin className="w-4 h-4 text-brand" />
          <span className="hidden xl:block truncate max-w-[110px] 2xl:max-w-[160px] font-medium text-slate-700">{activeName}</span>
          <ChevronDown className="w-3.5 h-3.5 text-slate-400" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white w-56">
        <DropdownMenuLabel className="text-xs text-muted-foreground">District context</DropdownMenuLabel>
        <DropdownMenuItem data-testid="district-opt-all" onClick={() => choose("")} className={!current ? "font-semibold text-brand" : ""}>All my districts</DropdownMenuItem>
        {districts.map((d) => (
          <DropdownMenuItem key={d.org_id} data-testid={`district-opt-${d.org_id}`} onClick={() => choose(d.org_id)}
            className={d.org_id === current ? "font-semibold text-brand" : ""}>{d.name}</DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
